// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".toastPaymentComponent-frameContainer{display:flex;height:600px}\n", "",{"version":3,"sources":["webpack://./src/css/paymentPage/subComponents/ToastPaymentComponent.scss"],"names":[],"mappings":"AACA,sCACE,YAAa,CACb,YAAa","sourcesContent":["\n.toastPaymentComponent-frameContainer {\n  display: flex;\n  height: 600px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
